/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsfielddescription2Inputs */

const en_groupsfielddescription2 = /** @type {(inputs: Groupsfielddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description (optional)`)
};

const de_groupsfielddescription2 = /** @type {(inputs: Groupsfielddescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung (freiwillig)`)
};

/**
* | output |
* | --- |
* | "Description (optional)" |
*
* @param {Groupsfielddescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsfielddescription2 = /** @type {((inputs?: Groupsfielddescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsfielddescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsfielddescription2(inputs)
	return de_groupsfielddescription2(inputs)
});
export { groupsfielddescription2 as "groupsFieldDescription" }